import { jsx as _jsx } from "react/jsx-runtime";
import { VIEWPORT_ICON_PATHS } from '../viewportIcons';
export function ViewportIcon({ kind }) {
    return _jsx("svg", { width: "16", height: "16", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": "true", focusable: "false", "data-viewport-icon": kind, style: { flexShrink: 0 }, children: _jsx("path", { d: VIEWPORT_ICON_PATHS[kind] }) });
}
//# sourceMappingURL=ViewportIcon.js.map